import { HttpResponse } from 'msw';

import { genBookingDataDoctor } from '@/shared/lib/msw/generators/doctor';

export const getBookingOnline = () => {
  return HttpResponse.json(
    {
      data: genBookingDataDoctor({
        doctorId: 1487,
        medcenterId: 139835,
        onlineBooking: {
          iinRequired: false,
          schedule: null,
          timeslotsIsEmpty: true,
          basedOn: 'preferred_time',
        },
      }),
    },
    { status: 200 },
  );
};

export const getBookingOnlineEmptySchedule = () => {
  return HttpResponse.json(
    {
      data: genBookingDataDoctor({
        doctorId: 30007,
        medcenterId: 139577,
        onlineBooking: {
          iinRequired: false,
          schedule: null,
          timeslotsIsEmpty: true,
          basedOn: 'preferred_time',
        },
      }),
    },
    { status: 200 },
  );
};

export const getBookingOnlineMedelementEmptySlots = () => {
  return HttpResponse.json(
    {
      data: genBookingDataDoctor({
        doctorId: 3204,
        medcenterId: 28,
        onlineBooking: {
          iinRequired: true,
          schedule: null,
          timeslotsIsEmpty: true,
          basedOn: 'medelement',
        },
      }),
    },
    { status: 200 },
  );
};
